import axios from "axios";

export default function (vesselId, licenceApplicationId, vesselName, accountingAuthorityIdentificationCodeId) {
    return (dispatch) => {
        var requestData = {
            vesselId,
            licenceApplicationId,
            vesselName,
            accountingAuthorityIdentificationCodeId
        };

        axios({
            method: "GET",
            url: "api/Vessel/CheckLicenceAmendment",
            params: requestData,
            withCredentials: true
        })
        .then((response) => {
            dispatch({
                type: "LICENCE_AMENDMENT",
                data: response.data
            });
        })
        .catch((error) => {
        });
    };
}
